import React from "react";
import { Modal, Button } from "antd";
import { useSelector } from "react-redux";
import { memo } from "react";

const RestoreDashboardModal = ({
  isModalShow,
  setRestoredDashboardModal,
  restroreDashboardFunction,
}) => {
  const handleCancel = () => {
    setRestoredDashboardModal(false);
  };

  const handleRestoreDashboard = (e) => {
    restroreDashboardFunction(false);
    setRestoredDashboardModal(false);
  };

  return (
    <Modal
      open={isModalShow}
      onOk={handleRestoreDashboard}
      onCancel={handleCancel}
      footer={[
        <Button type="button" className="btn_Clear" onClick={handleCancel}>
          No
        </Button>,
        <Button
          type="primary"
          className="ant-btn-primary_blue"
          onClick={handleRestoreDashboard}
        >
          Yes
        </Button>,
      ]}
      // width={"30%"}
      // height={"40rem"}
      closable={false}
      maskClosable={true}
    >
      <>
        <div className="mb-0 text_heading-Slab text-transform__none mt-2">
          Are you sure you want to restore the recommended dashboard?
        </div>
        <div className="text_regular mt-1">
          All your widgets changes will be lost if you proceed
        </div>
      </>
    </Modal>
  );
};

export default memo(RestoreDashboardModal);
